export const AUDIO_ENGINE_KEY = 'choirplayer.audioEngine.v1';
export const AUDIO_ENGINES = ['webaudio', 'superpowered'];

export function getAudioEngineChoice(storage) {
  try {
    const value = (storage || window.localStorage).getItem(AUDIO_ENGINE_KEY);
    return AUDIO_ENGINES.includes(value) ? value : 'webaudio';
  } catch (_) { return 'webaudio'; }
}

export async function switchAudioEngine(value, { persist, stop, reload, isRecording, storage } = {}) {
  if (!AUDIO_ENGINES.includes(value)) throw new Error('Unknown audio engine');
  if (isRecording && isRecording()) throw new Error('Stop recording before changing audio engine.');
  if (persist) await persist();
  if (isRecording && isRecording()) throw new Error('Stop recording before changing audio engine.');
  // Save successfully before stopping or reloading; blocked browser storage must not lose playback.
  try { (storage || window.localStorage).setItem(AUDIO_ENGINE_KEY, value); }
  catch (_) { throw new Error('The browser could not save the audio-engine choice.'); }
  try { if (stop) await stop(); }
  catch (error) { console.warn('Audio cleanup before engine reload:', error); }
  if (reload) reload();
}
